module.exports = __webpack_public_path__ + "static/media/iconmonstr-product-1.eeb8d8e6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/iconmonstr-product-1.svg
// module id = 276
// module chunks = 0